module.exports = __webpack_public_path__ + "img/3mbs-classic.fd59f653.png";